'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Tokens = require('csrf');
var tokens = new Tokens();

var wixCsrfInterceptor = function wixCsrfInterceptor(config) {
  var headers = config.headers;

  var secret = tokens.secretSync();
  var cookie = ['cookie', 'Cookie'].filter(function (prop) {
    return !!headers[prop];
  }).shift() || 'cookie';
  var cookies = headers[cookie] || [];
  headers[cookie] = ['XSRF-TOKEN=' + secret].concat(cookies).reverse().join('; ');
  headers.common['x-xsrf-token'] = secret;
  return config;
};

exports.default = { requestSuccess: wixCsrfInterceptor };
//# sourceMappingURL=axios-intercept-mock-csrf.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/axios-intercept-mock-csrf.js
// module id = 790
// module chunks = 0